import { Component, useRef } from 'react';
import { Accordion, Grid, Icon, Segment } from 'semantic-ui-react';
import { useWikiSearch } from '../WikiSearchContext';
import useHighlightMatches from '../useHighlightMatches';

class ParentGuardianGuideClass extends Component {
  state = { activeIndex: [0, 1, 2, 3] };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndex } = this.state;

    const newIndex = activeIndex.includes(index)
      ? activeIndex.filter((i) => i !== index)
      : [...activeIndex, index];

    this.setState({ activeIndex: newIndex });
  };

  render() {
    const { activeIndex } = this.state;
    const { contentRef } = this.props;

    return (
      <div ref={contentRef}>
        <Grid id="detailed-segment">
          <Grid.Column width={16}>
            <Segment.Group>
              <Segment
                basic
                attached="top"
                style={{ padding: '0' }}
                id="segment"
              >
                <Accordion styled fluid id="segment" exclusive={false}>
                  <Accordion.Title
                    active={activeIndex.includes(0)}
                    index={0}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Welcome to React
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(0)}>
                    <p>
                      The purpose of this guide is to help document what has
                      worked best for our families when utilizing our services.
                    </p>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(1)}
                    index={1}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Our Vision of Service
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(1)}>
                    <p>
                      Our services work best when the parents and guardians are
                      involved throughout the entire client-support cycle.
                      Parents and guardians are encouraged to stay in touch with
                      their Program Manager in terms of how things are going. In
                      order to ensure the best possible services be sure to:
                    </p>
                    <ul id="blue">
                      <li>
                        Review and initial sessions at the end of each day
                      </li>
                      <li>
                        Use the Parent/Guardian Feedback text box to let us know
                        how a session went
                      </li>
                      <li>
                        Provide feedback in the portal for 90 Day and CSR (6
                        month) Reviews
                      </li>
                      <li>
                        Let us know about what is working and what is not
                        working - as soon as possible
                      </li>
                    </ul>
                  </Accordion.Content>

                  <Accordion.Title
                    active={activeIndex.includes(2)}
                    index={2}
                    onClick={this.handleClick}
                    id="green"
                  >
                    <Icon name="dropdown" />
                    Expectations of Parents/Guardians
                  </Accordion.Title>
                  <Accordion.Content active={activeIndex.includes(2)}>
                    <p id="orange">
                      Parents and guardians, as well as other family supports
                      involved in services, are required to abide by specific
                      policies and procedures, in accordance with both the state
                      of Maine as well as the Company.
                    </p>
                    <p id="orange">
                      All families are required to abide by the following
                      policies:
                    </p>

                    <h4>Treatment Requirements</h4>

                    <p id="orange">
                      Parents and guardians are required to participate in the
                      treatment of their child to the greatest degree possible
                      in relation to individual needs, as well in relation to
                      family circumstance. Parents/guardians must oversee daily
                      services in their home and must provide their signature on
                      daily progress notes whenever a BHP is working with their
                      child. We are unable to bill for services that have not
                      been signed off by a parent/guardian which could result in
                      delayed payment for our BHP.
                    </p>

                    <p id="orange">
                      Our agency utilizes a web-based portal on a daily basis to
                      record notes, send feedback, and complete signatures.
                      Parents and guardians are required to use this portal for
                      signature purposes. It is optional for family to access
                      the portal for it’s other features, including sending
                      feedback, looking at progress notes, and reviewing service
                      details. Our agency also offers a Wiki for all handbooks
                      and guides to be accessed at any time.
                    </p>

                    <p id="orange">
                      This service is not intended to be used as a child-care
                      program or babysitting service. Parents and guardians must
                      involve themselves in all treatment. Families are expected
                      to utilize methods and strategies that are used by the
                      treatment team when the treatment team is not present.
                      Family members involved in treatment are counted on to
                      show consistency with treatment methods in order to
                      maximize progress and help their child obtain independence
                      in target areas.
                    </p>

                    <p id="orange">
                      You are required to communicate with, provide feedback to,
                      and meet monthly with your direct supervisor regarding
                      services provided to your child.
                    </p>

                    <p id="orange">
                      Parents/guardians are required to review and sign the
                      treatment plan that will be used. Treatment plans are
                      reviewed every 90 days and are used for a maximum of 180
                      days, at which point a Continued Stay Review (CSR) will be
                      conducted by the Program Development team and direct
                      Supervisor. CSRs and 90-day Reviews are required and the
                      family must participate.
                    </p>
                  </Accordion.Content>
                </Accordion>
              </Segment>
            </Segment.Group>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

const ParentGuardianGuide = (props) => {
  const { searchTerm } = useWikiSearch();
  const contentRef = useRef(null);
  useHighlightMatches(contentRef);

  return (
    <ParentGuardianGuideClass
      {...props}
      searchTerm={searchTerm}
      contentRef={contentRef}
    />
  );
};

export default ParentGuardianGuide;
